var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8294 19.5857L28.5742 18.3305L20.4153 10.1716C20.3054 10.0617 20.1564 10 20.001 10C19.8455 10 19.6965 10.0617 19.5866 10.1716L10.1726 19.5857C9.94377 19.8145 9.94377 20.1855 10.1726 20.4144C10.4014 20.6431 10.7724 20.6431 11.0012 20.4144L11.2562 20.1594V29.4141C11.2562 29.7377 11.5185 30 11.8421 30H17.5323V23.138C17.5323 22.8144 17.7946 22.5521 18.1182 22.5521H21.8838C22.2074 22.5521 22.4697 22.8144 22.4697 23.138V30H28.1599C28.4835 30 28.7458 29.7377 28.7458 29.4141V20.1594L29.0007 20.4143C29.1152 20.5287 29.2651 20.586 29.4151 20.586C29.565 20.586 29.715 20.5287 29.8293 20.4143C30.0582 20.1855 30.0582 19.8145 29.8294 19.5857Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.be1a3ef187d031492a1b1d569371bf73.svg";
export { ForwardRef as ReactComponent };